import { dateFormat } from 'shared/util'
import {
	Stack,
	ListItem,
	ListItemButton,
	Typography,
	ListItemProps
} from '@mui/material'
import { LvProjectResult } from 'interface/carenet/lv'

type LvProjectRecordProps = {
	project: LvProjectResult
	onOpenProject: (project: LvProjectResult) => void
} & ListItemProps
export const LvProjectRecord = ({
	project,
	onOpenProject,
	...others
}: LvProjectRecordProps) => {
	return (
		<ListItem {...others} disablePadding>
			<ListItemButton onClick={() => onOpenProject(project)} disableGutters disableRipple sx={{ paddingX: 1 }}>
				<Stack direction="row" spacing={1} alignItems="flex-start" width="100%" boxSizing="border-box">
					<Typography variant="body2" color="text.secondary" whiteSpace="nowrap">
						{dateFormat(project.broadcastStartDate, { wareki: false })}
					</Typography>
					<div
						dangerouslySetInnerHTML={{
							__html: project.projectName ?? 'empty'
						}}
						style={{
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							flexGrow: 1
						}}
					/>
					<Typography variant="body2" color="text.secondary" whiteSpace="nowrap">
						{project.productName}
					</Typography>
				</Stack>
			</ListItemButton>
		</ListItem>
	)
}
